import { getActivePinia } from "pinia";
import { z } from "zod";

import { AccessService } from "./AccessService";
import { ApiService } from "./ApiService";
import { GrantedPermissions } from "./PermissionsService";
import type { IExtendedPinia } from "./interfaces/IExtendedPinia";

const SignInResponse = z.object({
    token: z.string(),
    permissions: GrantedPermissions,
});
type SignInResponse = z.infer<typeof SignInResponse>;

class AuthenticationService extends ApiService {
    get token(): string | null {
        return localStorage.getItem("token");
    }

    isAuthenticated(): boolean {
        return this.token !== null;
    }

    async signIn(email: string, password: string): Promise<void> {
        const response = await this.post<SignInResponse>("sign_in", { email, password });
        const data = SignInResponse.parse(response);
        localStorage.setItem("token", data.token);
        AccessService.setPermissions(response.permissions);
    }

    signOut(): void {
        localStorage.removeItem("token");
        localStorage.removeItem("permissions");

        // reset all pinia stores
        const activePinia = getActivePinia() as IExtendedPinia;
        if (activePinia) {
            activePinia._s.forEach((store) => store.$reset());
        }
    }
}

export default new AuthenticationService();
